import { render } from "./CompetitiveAadvantages.vue?vue&type=template&id=31432156&scoped=true"
import script from "./CompetitiveAadvantages.vue?vue&type=script&lang=js"
export * from "./CompetitiveAadvantages.vue?vue&type=script&lang=js"

import "./CompetitiveAadvantages.vue?vue&type=style&index=0&id=31432156&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31432156"]])

export default __exports__